// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__HDJu4","actions":"GroupTable_actions__2PhBQ","deleteModalFooter":"GroupTable_deleteModalFooter__2cwxF"};